import log from 'loglevel';

/**
 * Retrieve caches object.
 */
export function getCaches(): CacheStorage | undefined {
  return window.caches;
}

/**
 * Returns true if cache is supported.
 * @returns true if Cache is supported.
 */
export function isSupported(): boolean {
  if (getCaches()) {
    return true;
  }
  log.error('Web Cache not supported');
  return false;
}

/**
 * Open a Cache object.
 * @param cacheName - The name of the cache you want to open.
 */
export async function open(cacheName: string): Promise<Cache> {
  const caches = getCaches()!;
  return caches.open(cacheName);
}

/**
 * Add resources to cache.
 * @param cacheName - The name of the cache.
 * @param resources - The resources to add to the cache.
 */
export async function addAll(cacheName: string, resources: RequestInfo[]) {
  const cache = await open(cacheName);
  await cache.addAll(resources);
}

/**
 * Delete a cache object.
 * @param cacheName - The name of the cache.
 */
export async function deleteOne(cacheName: string) {
  const caches = getCaches()!;
  await caches.delete(cacheName);
}

/**
 * If cache name isn't present in the list of keep names, then delete it.
 * @param keepList -
 */
export async function deleteUnknown(keepList: string[]) {
  const caches = getCaches()!;
  const keys = await caches.keys();
  const keysToDelete = keys.filter(key => !keepList.includes(key));
  await Promise.all(keysToDelete.map(deleteOne));
}
